var _excluded = ["_disabled", "inputFilled"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Booking, BookingFilled } from '@gympass/yoga-icons';
import { Text } from '@gympass/yoga';
import styled, { css } from 'styled-components';
import { bool, oneOf, func, instanceOf, string } from 'prop-types';
import moment from 'moment';
import { theme } from '../../Theme';
import Calendar from './Calendar';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: ", ";\n"])), function (props) {
  return props.fullWidth ? '100%' : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          ", "px\n        "])), theme.components.input.width);
});

var getSelectorBorderColor = function getSelectorBorderColor(open, error, disabled, colors, input) {
  if (error) {
    return colors.feedback.attention[1];
  }

  if (disabled) {
    return colors.elements.backgroundAndDisabled;
  }

  if (open) {
    return colors.deep;
  }

  return input.border.color["default"];
};

var Selector = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var open = _ref.open,
      error = _ref.error,
      disabled = _ref.disabled,
      _ref$theme$yoga = _ref.theme.yoga,
      components = _ref$theme$yoga.components,
      colors = _ref$theme$yoga.colors,
      spacing = _ref$theme$yoga.spacing;
  return "\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    box-sizing: border-box;\n    height: " + components.input.height + "px;\n    width: 100%;\n    padding: " + spacing.small + "px;\n    background-color: " + colors.white + ";\n    border-radius: " + components.input.border.radius + "px;\n    border-width: " + components.input.border.width + "px;\n    border-style: solid;\n    border-color: " + getSelectorBorderColor(open, error, disabled, colors, components.input) + "\n    color: " + components.input.font.color.focus + ";\n  ";
});
var Input = styled(Text.Small)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var disabled = _ref2.disabled,
      colors = _ref2.theme.yoga.colors;
  return "\n    width: 100%;\n    padding: 0;\n    border: none;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: " + (!disabled ? colors.text.primary : colors.text.disabled) + "\n  ";
});
var InputPlaceholder = styled(Text.Small)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var disabled = _ref3.disabled,
      colors = _ref3.theme.yoga.colors;
  return "\n    color: " + (!disabled ? colors.text.secondary : colors.text.disabled) + "\n  ";
});
var TButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-end;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  cursor: pointer;\n"])));
var Panel = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var _ref4$theme$yoga = _ref4.theme.yoga,
      components = _ref4$theme$yoga.components,
      colors = _ref4$theme$yoga.colors,
      radii = _ref4$theme$yoga.radii,
      borders = _ref4$theme$yoga.borders,
      spacing = _ref4$theme$yoga.spacing;
  return "\n    position: absolute;\n    background-color: " + colors.white + ";\n    border: " + borders.small + "px solid " + colors.elements.lineAndBorders + ";\n    z-index: 1;\n    width: " + components.input.width + "px;\n    left: 0;\n    border-radius: " + radii.regular + "px;\n    margin-top: " + spacing.xxsmall + "px;\n  ";
});
var CalendarIcon = styled(function (_ref5) {
  var _disabled = _ref5._disabled,
      inputFilled = _ref5.inputFilled,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded);

  return !inputFilled ? /*#__PURE__*/React.createElement(Booking, _extends({
    width: 20,
    height: 20
  }, props)) : /*#__PURE__*/React.createElement(BookingFilled, _extends({
    width: 20,
    height: 20
  }, props));
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref6) {
  var disabled = _ref6.disabled,
      _ref6$theme$yoga = _ref6.theme.yoga,
      colors = _ref6$theme$yoga.colors,
      spacing = _ref6$theme$yoga.spacing;
  return "\n    fill: " + (disabled ? colors.text.disabled : colors.text.primary) + ";\n    margin-right: " + spacing.xxsmall + "px;\n  ";
});
var ErrorWrapper = styled(Text.Small)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref7) {
  var _ref7$theme$yoga = _ref7.theme.yoga,
      colors = _ref7$theme$yoga.colors,
      components = _ref7$theme$yoga.components;
  return "\n    margin-top: " + components.input.helper.margin.top + "px;\n    font-size: " + components.input.helper.font.size + "px;\n    color: " + colors.feedback.attention[1] + ";\n    position: absolute;\n  ";
});
export var toUTC = function toUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};

function Datepicker(_ref8) {
  var fullWidth = _ref8.fullWidth,
      type = _ref8.type,
      placeholder = _ref8.placeholder,
      startDate = _ref8.startDate,
      endDate = _ref8.endDate,
      onSelectSingle = _ref8.onSelectSingle,
      disabled = _ref8.disabled,
      onSelectRange = _ref8.onSelectRange,
      disablePastDates = _ref8.disablePastDates,
      disableFutureDates = _ref8.disableFutureDates,
      error = _ref8.error,
      onOpen = _ref8.onOpen;

  var _useState = useState(),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(startDate),
      startD = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = useState(endDate),
      endD = _useState3[0],
      setEndDate = _useState3[1];

  var ref = useRef(null);

  var _useState4 = useState(false),
      inputFilled = _useState4[0],
      setInputFilled = _useState4[1];

  var triggerOnOpen = useCallback(function () {
    if (onOpen) onOpen(open === 'true');
  }, [open]);

  var onBlur = function onBlur() {
    setOpen(false.toString());
    triggerOnOpen();
  };

  useEffect(function () {
    if (type === 'single' && onSelectSingle) {
      onSelectSingle(startD);
      setOpen(false.toString());
    } else if (type === 'range' && onSelectRange) {
      onSelectRange(startD, endD);
    }

    setInputFilled(!!startD);
  }, [startD, endD]);

  var onDateSingleSelect = function onDateSingleSelect(startLocal) {
    setStartDate(startLocal);
  };

  useEffect(function () {
    if (open === 'true') ref.current.focus();
  }, [open]);

  var onDateRangeSelect = function onDateRangeSelect(selectedDate) {
    if (!endD) {
      if (!startD) {
        setStartDate(selectedDate);
      } else if (selectedDate < startD) {
        setStartDate(selectedDate);
        setEndDate(undefined);
      } else setEndDate(selectedDate);
    } else {
      setStartDate(selectedDate);
      setEndDate(undefined);
    }
  };

  var renderInput = function renderInput() {
    if (!startD && !endD) {
      return /*#__PURE__*/React.createElement(InputPlaceholder, {
        disabled: disabled
      }, placeholder != null ? placeholder : "Select Date");
    }

    var dateFormat = 'MMM D, YYYY';
    return startD && /*#__PURE__*/React.createElement(Input, {
      disabled: disabled
    }, moment(startD).format(dateFormat), endD && " - " + moment(endD).format(dateFormat));
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    fullWidth: fullWidth,
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement(Selector, {
    open: open === 'true',
    disabled: disabled,
    error: error
  }, renderInput(), /*#__PURE__*/React.createElement(TButton, {
    onClick: function onClick() {
      if (!disabled) {
        setOpen((open !== 'true').toString());
      }

      triggerOnOpen();
    }
  }, /*#__PURE__*/React.createElement(CalendarIcon, {
    disabled: disabled,
    inputFilled: inputFilled
  }))), error && /*#__PURE__*/React.createElement(ErrorWrapper, null, error), open === 'true' && /*#__PURE__*/React.createElement(Panel, {
    tabIndex: -1,
    ref: ref,
    onBlur: onBlur
  }, /*#__PURE__*/React.createElement(Calendar, {
    type: type,
    startDate: startD,
    endDate: endD,
    onSelectSingle: onDateSingleSelect,
    onSelectRange: onDateRangeSelect,
    disablePastDates: disablePastDates,
    disableFutureDates: disableFutureDates
  })));
}

Datepicker.propTypes = {
  fullWidth: bool,
  type: oneOf(['single', 'range']).isRequired,
  placeholder: string,
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
  disabled: bool,
  onSelectSingle: func,
  onSelectRange: func,
  disablePastDates: bool,
  disableFutureDates: bool,
  error: string,
  onOpen: func
};
Datepicker.defaultProps = {
  fullWidth: false,
  placeholder: undefined,
  startDate: undefined,
  endDate: undefined,
  disabled: false,
  onSelectSingle: undefined,
  onSelectRange: undefined,
  disablePastDates: false,
  disableFutureDates: false,
  error: undefined,
  onOpen: undefined
};
export default Datepicker;